<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Example" />
    <vc-lorem-ipsum :repeats="5" />
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'PageLoremIpsum',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/lorem-ipsum.vue